import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, RaisedButton } from 'material-ui';
import { CheckDiffText } from '../../common/utils';

const LiftAndCranesApproval = ({
    originalValues,
    changedValues,
    onApprove,
    onReject,
}) => {
    const items = React.useMemo(
        () => 
            Object.entries(changedValues).map(([key, value]) => ({
                ...value,
                name: key,
                label: `${key} mt:`,
            })), 
        [changedValues],
    );

    return (
        <React.Fragment>
            <div className='lift-and-cranes' style={{ margin: 'unset' }}>
                {items.map((liftCrane, index) => (
                    <LiftAndCranesItem
                        key={`${liftCrane.name}_${index}`}
                        liftCrane={liftCrane}
                        port={{ liftsCranes: originalValues }}
                        newPort={{ liftsCranes: changedValues }}
                    />
                ))}
            </div>

            <div className="form-actions">
                <RaisedButton
                    label="Approve"
                    primary
                    onClick={() => onApprove('liftsCranes')}
                />
                <RaisedButton
                    label="Reject"
                    secondary
                    onClick={() => onReject('liftsCranes')}
                />
            </div>
        </React.Fragment>
    );
};

LiftAndCranesApproval.propTypes = {
    originalValues: PropTypes.object.isRequired,
    changedValues: PropTypes.object.isRequired,
    onApprove: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
};

export default LiftAndCranesApproval;

const LiftAndCranesItem = ({ liftCrane, port, newPort }) => (
    <Fragment>
        <div className='line-head'>
            <div className='row'>
                <div className={
                    port.liftsCranes && newPort.liftsCranes[liftCrane.name].checked !== port.liftsCranes[liftCrane.name].checked
                        ? 'col-xs-12 middle-xs dirty-element'
                        : 'col-xs-12 middle-xs'
                }
                >
                    <Checkbox
                        name={`liftsCranes.${liftCrane.name}.checked`}
                        label={liftCrane.label}
                        labelStyle={{ fontSize: '14px' }}
                        style={{ width: '750px' }}
                        disabled
                        checked={newPort.liftsCranes[liftCrane.name].checked}
                    />
                </div>
            </div>
        </div>

        <div className='line-body'>
            {liftCrane.details.map((detail, index) => (
                <Fragment key={index}>
                    {(detail.status === 'new' || detail.status === 'normal') && (
                        <div className={detail.status === 'new' ? 'item middle-xs dirty-element' : 'item middle-xs '}>
                            <div className='count'>{detail ? detail.value : ''} mt</div>
                            <div className='name'>{detail ? detail.name : ''}</div>
                        </div>
                    )}

                    {detail.status === 'remove' && (
                        <div className='item middle-xs dirty-element'>
                            <div className='count'>
                                <CheckDiffText
                                    oldValue={detail ? detail.value : ''}
                                    newValue={null}
                                /> mt
                            </div>
                            <div className='name'>
                                <CheckDiffText
                                    oldValue={detail ? detail.name : ''}
                                    newValue={null}
                                />
                            </div>
                        </div>
                    )}

                    {detail.status === 'change' && (
                        <div className='item middle-xs dirty-element'>
                            <div className='count'>
                                <CheckDiffText
                                    oldValue={detail ? detail.value : ''}
                                    newValue={detail.changes.value ? detail.changes.value : ''}
                                /> mt
                            </div>
                            <div className='name'>
                                <CheckDiffText
                                    oldValue={detail ? detail.name : ''}
                                    newValue={detail.changes.name ? detail.changes.name : ''}
                                />
                            </div>
                        </div>
                    )}
                </Fragment>
            ))}
        </div>
    </Fragment>
);



// WEBPACK FOOTER //
// ./app/components/Regions/PortManagement/blocks/LiftAndCranes/LiftAndCranesApproval.jsx